import type { FeeEstimate, FeeEstimatePayload } from '@common/types/quoteTemplates';
import axiosInstance from '@/services/axiosInstance';

export async function getTitleInsuranceEstimates(quoteTemplateId: string) {
    return axiosInstance.get<FeeEstimate[]>(
        `/api/v1/quote-templates/${quoteTemplateId}/title-insurance-estimates`,
    );
}

export async function addNewTitleInsuranceEstimates(
    quoteTemplateId: number,
    payload: FeeEstimatePayload[],
) {
    return axiosInstance.post<FeeEstimate[]>(
        `/api/v1/quote-templates/${quoteTemplateId}/title-insurance-estimates`,
        payload,
    );
}

export async function updateTitleInsurance(feeEstimateId: number, payload: FeeEstimatePayload) {
    return axiosInstance.put<FeeEstimate>(
        `/api/v1/quote-templates/${feeEstimateId}/title-insurance-estimates`,
        payload,
    );
}

export async function deleteTitleInsuranceEstimates(feeEstimateId: number) {
    return axiosInstance.delete<null>(
        `/api/v1/quote-templates/${feeEstimateId}/title-insurance-estimates`,
    );
}

export async function deleteDisbursement(id: number | string) {
    return axiosInstance.delete<null>(`/api/v1/quote-templates/${id}/disbursements-estimates`);
}

export async function editDisbursement(id: number | string, payload: FeeEstimatePayload) {
    return axiosInstance.put<FeeEstimate>(
        `/api/v1/quote-templates/${id}/disbursements-estimates`,
        payload,
    );
}

export async function deleteRegistrationFees(id: number | string) {
    return axiosInstance.delete<null>(`/api/v1/quote-templates/${id}/registration-fees-estimates`);
}

export async function editRegistrationFees(id: number | string, payload: FeeEstimatePayload) {
    return axiosInstance.put<FeeEstimate>(
        `/api/v1/quote-templates/${id}/registration-fees-estimates`,
        payload,
    );
}
